export const EmbeddedStripeCheckoutSessionSkeleton = () => (
  <div className="flex min-w-[450px] items-center justify-center gap-6 lg:min-w-[1000px]">
    <div className="h-[560px] w-full animate-pulse rounded-lg bg-gray-500 lg:h-[425px]" />
    <div className="hidden h-[425px] w-full animate-pulse rounded-lg bg-gray-500 lg:block" />
  </div>
)
